export default "__VITE_ASSET__Dxon8G6q__"